import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { SHARE_SURFACES } from 'SocialLinks/shareNatively'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import OrderSummary from 'containers/welcome/OrderSummary'

import { ReferAFriend } from '../OrderConfirmation/components/ReferAFriend'
import {
  RafBannerCard,
  useRafBanner,
} from '../OrderConfirmation/components/ReferAFriend/experiments/RafBanner'
import { AppPromo } from './AppPromo'
import { OrderSchedule } from './OrderSchedule'
import { WelcomeFirstBoxOrderWrapper } from './WelcomeFirstBoxOrderWrapper'

import css from './Welcome.css'

const propTypes = {
  device: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  params: PropTypes.shape({
    orderId: PropTypes.string,
  }).isRequired,
  query: PropTypes.shape({
    var: PropTypes.string,
  }).isRequired,
  trackWelcomeAppPromoClick: PropTypes.func.isRequired,
  userFetchReferralOffer: PropTypes.func.isRequired,
  addRecipeToBasket: PropTypes.func.isRequired,
  userLoadData: PropTypes.func.isRequired,
  isSignUpSeamlessFlowIntoPlanningEnabled: PropTypes.bool.isRequired,
}

// Scoped to just the RAF placement so the rest of the column stays a direct,
// shallow-render-visible child of Welcome.
const RafBannerConnector = ({ orderId, children }) => children(useRafBanner(orderId))

RafBannerConnector.propTypes = {
  orderId: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
}

class Welcome extends React.PureComponent {
  componentDidMount() {
    const {
      query = {},
      params = {},
      fetchData,
      addRecipeToBasket,
      userFetchReferralOffer,
      userLoadData,
    } = this.props

    userLoadData()
    userFetchReferralOffer()
    fetchData({ query, params }, addRecipeToBasket)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const {
      device,
      trackWelcomeAppPromoClick,
      isSignUpSeamlessFlowIntoPlanningEnabled,
      params: { orderId },
    } = this.props

    if (isSignUpSeamlessFlowIntoPlanningEnabled) {
      return (
        <div data-testid="rockets_seamless_flow_into_planning">
          <WelcomeFirstBoxOrderWrapper
            isSignUpSeamlessFlowIntoPlanningEnabled={isSignUpSeamlessFlowIntoPlanningEnabled}
          />
        </div>
      )
    } else {
      return (
        <section className={css.container} data-testid="welcomeContainer">
          <div className={classnames(css.contentContainer)}>
            <div className={css.row}>
              <div className={css.colMedium}>
                <div className={css.welcomeColInnerContainer}>
                  <OrderSchedule />
                  <div className={classnames(css.welcomeColInner, css.appPromo)}>
                    <AppPromo
                      device={device}
                      trackWelcomeAppPromoClick={trackWelcomeAppPromoClick}
                    />
                  </div>
                </div>
                <RafBannerConnector orderId={orderId}>
                  {(rafBannerResult) =>
                    rafBannerResult.status === 'banner' ? (
                      <div
                        className={classnames(css.welcomeColInner, css.mobileShow, css.rafMobile)}
                      >
                        <RafBannerCard
                          data={rafBannerResult.data}
                          orderId={orderId}
                          surface={SHARE_SURFACES.welcome}
                        />
                      </div>
                    ) : (
                      rafBannerResult.status === 'none' && (
                        <ReferAFriend
                          surface={SHARE_SURFACES.welcome}
                          renderWrapper={(inviteSection) => (
                            <div
                              className={classnames(
                                css.welcomeColInner,
                                css.mobileShow,
                                css.rafMobile,
                              )}
                            >
                              <Box paddingH={4} paddingV={4}>
                                {inviteSection}
                              </Box>
                            </div>
                          )}
                        />
                      )
                    )
                  }
                </RafBannerConnector>
              </div>
              <div className={classnames(css.colSmall, css.mobileHide)}>
                <div className={classnames(css.welcomeColInner, css.orderSummaryWrapper)}>
                  <OrderSummary />
                </div>
                <RafBannerConnector orderId={orderId}>
                  {(rafBannerResult) =>
                    rafBannerResult.status === 'banner' ? (
                      <div className={classnames(css.welcomeColInner, css.rafDesktopWrapper)}>
                        <RafBannerCard
                          data={rafBannerResult.data}
                          orderId={orderId}
                          surface={SHARE_SURFACES.welcome}
                        />
                      </div>
                    ) : (
                      rafBannerResult.status === 'none' && (
                        <ReferAFriend
                          surface={SHARE_SURFACES.welcome}
                          renderWrapper={(inviteSection) => (
                            <div className={classnames(css.welcomeColInner, css.rafDesktopWrapper)}>
                              {inviteSection}
                            </div>
                          )}
                        />
                      )
                    )
                  }
                </RafBannerConnector>
              </div>
            </div>
          </div>
        </section>
      )
    }
  }
}

Welcome.propTypes = propTypes

export { Welcome, RafBannerConnector }
